'use strict';
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/brands.min.css';
import 'nprogress/css/nprogress.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as ConfirmDialog from 'vuejs-confirm-dialog'

//  global components
import Pagination from '@/_core/components/pagination.vue';
import SortField from '@/_core/components/sortfield.vue';
import TableList from '@/_core/components/table-list.vue';
import Toasts from '@/_core/components/Toasts/Toasts.vue';

import PageHeader from '@/_common/_pageHeader.vue';
import PageMessages from '@/_common/_pageMessages.vue';
import PageBody from '@/_common/_pageBody.vue';

import { router } from './routes';
import App from './App.vue';

const app = createApp(App);

app.use(createPinia());
app.use(ConfirmDialog);
app.use(router);

app.component('m-pagination', Pagination);
app.component('sort-field', SortField);
app.component('table-list', TableList);
app.component('Toasts', Toasts);
app.component('PageHeader', PageHeader);
app.component('PageMessages', PageMessages);
app.component('PageBody', PageBody);

const configJson = {
    API_URL: '/',
    appName: import.meta.env.VITE_APP_NAME,
    appShortName: import.meta.env.VITE_APP_SHORTNAME
};

app.provide('$config', configJson);

app.mount('#app');